// extracted by mini-css-extract-plugin
export default {"footer":"YizOSLhjadluRclSSCU3","active":"AWQXqdzSACRaO784jeLK","footerOptions":"e9TXKO3vDPpU7gNg79UG","footerDisplay":"Wsa6pcMjkAPBZdAPdAp1","footerOption":"RFKQlS3KKJlCXNFj4sqF"};